import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/components/feature/Footer';
import ContactBanner from './components/ContactBanner';
import ContactInfo from './components/ContactInfo';
import ContactForm from './components/ContactForm';
import MapSection from './components/MapSection';
import SeoHead from '@/components/feature/SeoHead';
import { useTranslation } from 'react-i18next';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const CONTACT_JSONLD = [
  {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: '联系 Koorpet - 猫抓板咨询与合作',
    description: '联系 Koorpet，获取猫抓板产品咨询、批发合作、定制服务等支持。',
    url: `${siteUrl}/contact`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: '联系我们', item: `${siteUrl}/contact` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Koorpet',
    url: siteUrl,
    email: 'cs@koorpet.com',
    description: '专注猫抓板研发生产，提供瓦楞纸猫抓板、剑麻猫抓柱等优质宠物用品',
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'HK',
      addressRegion: 'Kowloon',
      addressLocality: 'Mongkok',
      streetAddress: 'FLAT /RM A 9/F SILVERCORP INTERNATIONAL TOWER 707-713 NATHAN ROAD',
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '18:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Saturday'],
        opens: '09:00',
        closes: '17:00',
      },
    ],
    priceRange: '¥¥',
  },
];

export default function ContactPage() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <SeoHead
        title="联系 Koorpet - 猫抓板咨询与合作 | 天然环保宠物用品"
        description="联系 Koorpet，获取猫抓板产品咨询、批发合作、定制服务等支持，工作日9:00-18:00在线服务。"
        keywords="联系 Koorpet,猫抓板咨询,宠物用品批发,定制猫抓板"
        canonical="/contact"
        ogImage="https://readdy.ai/api/search-image?query=customer%20service%20contact%20warm%20office%20professional%20friendly%20team%20natural%20light%20minimalist&width=1200&height=630&seq=og-contact-001&orientation=landscape"
        jsonLd={CONTACT_JSONLD}
      />
      <Navbar />

      <ContactBanner />

      <main className="max-w-7xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <ContactInfo />

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <ContactForm />
          <MapSection />
        </div>

        <div className="mt-12 bg-gradient-to-br from-[#3d2314] to-[#5c3520] rounded-2xl p-8 md:p-10">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div>
              <h3 className="text-white text-xl font-bold mb-2">{t('contact_cta_title')}</h3>
              <p className="text-white/60 text-sm">
                {t('contact_cta_desc')} <strong className="text-[#f5c9a8]">cs@koorpet.com</strong>
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
              <a
                href="/products"
                className="px-6 py-3 rounded-full bg-white text-[#3d2314] font-semibold text-sm hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-shopping-bag-line"></i>
                {t('contact_cta_btn_browse')}
              </a>
              <a
                href="mailto:cs@koorpet.com"
                className="px-6 py-3 rounded-full border border-white/40 text-white font-semibold text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-mail-line"></i>
                {t('contact_cta_btn_email')}
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}